import { clanFormInput, clanFormSchema } from '~/util/forms/clan';
import { ApiMutationOptions } from '~/util/hooks/useApiMutation';
import { Clan } from '~/util/types/clans';

export type editClanStaffMutationType = {
    clan: clanFormInput;
    existingClan: clanFormInput;
    existingClanId: string;
};

export const editClanStaffMutation = (): ApiMutationOptions<
    Clan,
    editClanStaffMutationType
> => ({
    buildRequest: ({ clan, existingClanId }) => {
        return {
            path: '/clans/' + existingClanId,
            method: 'PATCH',
            attachAuth: true,
            body: clanFormSchema.parse(clan),
        };
    },
    invalidateQueries: ({ variables: { existingClanId } }) => [
        'clan',
        existingClanId,
    ],
    toastMessages: {
        loading: 'Updating clan...',
        error: 'Failed to update clan: ',
        success: 'Clan updated successfully',
    },
});

export type addClanMemberStaffMutationType = {
    memberid: string;
    clanid: string;
};

export const addClanMemberStaffMutation = (): ApiMutationOptions<
    Clan,
    addClanMemberStaffMutationType
> => ({
    buildRequest: ({ memberid, clanid }) => {
        return {
            path: '/clans/' + clanid + '/members',
            method: 'POST',
            attachAuth: true,
            body: [memberid],
        };
    },
    invalidateQueries: ({ variables: { clanid } }) => ['clan', clanid],
    toastMessages: {
        loading: 'Adding member to clan...',
        error: 'Failed to add member to clan: ',
        success: 'Member added to clan successfully',
    },
});

export const createClanStaffMutation = (): ApiMutationOptions<
    Clan,
    clanFormInput
> => ({
    buildRequest: (clan) => {
        return {
            path: '/clans/placeholder',
            method: 'POST',
            attachAuth: true,
            body: clanFormSchema.parse(clan),
        };
    },
    invalidateQueries: ['clans'],
    toastMessages: {
        loading: 'Creating clan...',
        error: 'Failed to create clan: ',
        success: 'Clan created successfully',
    },
});
